import React, { useState, useEffect, useRef } from 'react';
import SmsVerificationSC from './sms-verification.styled';
import { HeadingTwo, BodyText, SmallText } from '../typography';
import dlt from '../../utils/default-lang';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Button from '../ui/button';
import ReactCodeInput from 'react-code-input';
import InlineLoading from '../ui/inline-loading';

const SmsVerification = ({
  additionalData,
  additionalInfo,
  onSubmit,
  isError,
  onResend,
  isSending,
  onBadSms,
  errorMessage,
}) => {
  const codeRef = useRef(undefined);
  const [smsValue, setSmsValue] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [isBadSms, setIsBadSms] = useState(false);

  useEffect(() => {
    if (smsValue.length < 4) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [smsValue]);

  const clearInputs = () => {
    codeRef.current.state.input[0] = '';
    codeRef.current.state.input[1] = '';
    codeRef.current.state.input[2] = '';
    codeRef.current.state.input[3] = '';
  };

  useEffect(() => {
    if (isError) {
      setIsDisabled(false);
      setIsBadSms(true);
      setSmsValue('');
      clearInputs();

      setTimeout(() => {
        setIsBadSms(false);
        onBadSms();
      }, 3500);
    }
  }, [isError, onBadSms]);

  const sendSmsAgain = () => {
    onResend(additionalData.type);
  };

  const sendValue = () => {
    const dataToSend = {
      sms_code: smsValue,
      ...additionalData,
    };

    onSubmit(dataToSend);
  };

  const onKeyDownSend = (e) => {
    if (e.keyCode === 13) {
      if (isDisabled || isSending) {
        return;
      } else {
        sendValue();
      }
    }
  };

  return (
    <SmsVerificationSC onKeyDown={(e) => onKeyDownSend(e)}>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">
          <FormattedHTMLMessage
            id="sms_verification_headline"
            defaultMessage={dlt['sms_verification_headline']}
          />
        </HeadingTwo>
        <BodyText>
          <FormattedHTMLMessage
            id="sms_verification_subtext"
            defaultMessage={dlt['sms_verification_subtext']}
          />
        </BodyText>
      </div>
      <div className="sms-input-wrap">
        <ReactCodeInput
          type="text"
          ref={codeRef}
          fields={4}
          className={isBadSms ? 'sms-code bad-sms' : 'sms-code'}
          onChange={(val) => setSmsValue(val.replace(/\D/g, ''))}
          value={smsValue}
        />

        {isBadSms ? (
          <BodyText className="red bolder">
            <FormattedHTMLMessage
              id="sms_verification_bad_sms"
              defaultMessage={dlt['sms_verification_bad_sms']}
            />
          </BodyText>
        ) : null}

        {errorMessage !== '' && (
          <BodyText className="red bolder">
            <FormattedHTMLMessage id={errorMessage} defaultMessage={dlt[errorMessage]} />
          </BodyText>
        )}

        <Button
          type="PRIMARY"
          onClick={() => sendValue()}
          disabled={isDisabled || isSending || errorMessage !== ''}
          className={isSending ? 'sending' : ''}
        >
          {isSending ? (
            <InlineLoading className="white" />
          ) : (
            <FormattedMessage
              id="sms_verification_btn"
              defaultMessage={dlt['sms_verification_btn']}
            />
          )}
        </Button>
      </div>

      {additionalInfo && additionalInfo !== '' ? (
        <div className="bottom-resend-wrap">
          <SmallText className="black-transparent align-justify">
            <FormattedHTMLMessage id={additionalInfo} defaultMessage={dlt[`${additionalInfo}`]} />
          </SmallText>
        </div>
      ) : null}

      <div className="bottom-resend-wrap">
        <SmallText className="black-transparent">
          <FormattedHTMLMessage
            id="sms_verification_not_coming"
            defaultMessage={dlt['sms_verification_not_coming']}
          />
        </SmallText>
        <Button type="LINK" onClick={() => sendSmsAgain()}>
          <FormattedHTMLMessage
            id="sms_verification_resend_btn"
            defaultMessage={dlt['sms_verification_resend_btn']}
          />
        </Button>
      </div>
    </SmsVerificationSC>
  );
};

SmsVerification.defaultProps = {
  isSending: false,
  isError: false,
  errorMessage: '',
};

export default SmsVerification;
